import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  theme: "light",
  language: "en",
  userInfo: null,
  permissions: [],
};

const GlobalVariablesSlice = createSlice({
  name: "globalVariables",
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setCompanyId: (state, action) => {
      state.company_id = action.payload;
    },
    setCompanyAddress: (state, action) => {
      state.company_address = action.payload;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setCompanyName: (state, action) => {
      state.company_name = action.payload;
    },
    setpermissions: (state, action) => {
      state.permissions = action.payload;
    },
  },
});

export const { setTheme,setCompanyId,setCompanyAddress,setUserId,setCompanyName,setpermissions  } =
  GlobalVariablesSlice.actions;

export default GlobalVariablesSlice.reducer;

